<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-expansion-panels>
        <v-expansion-panel
          v-for="(item, i) in triggersList"
          :key="i"
        >
          <v-expansion-panel-header>
            Trigger Notifications for this opportunity
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="py-2"
                  rounded
                  color="primary"
                  dark
                  small
                  v-on="on"
                  :loading="item.loading"
                  @click="onTriggerClick(item)"
                  v-html="item.title"
                />
              </template>
              <span>{{ item.hint }}</span>
            </v-tooltip>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import { waitAsync } from '@/utils/common'
import { IOpportunity } from '@/types/models/opportunity.model'


@Component
export default class OpportunityNotificationsTrigger extends Vue {
  @Prop({ required: true }) opportunity: IOpportunity

  triggersList: any[] = [
    {
      id: 'NOT7',
      hint: 'Send "Opportunity published" email notification to all users',
      title: 'Opportunity published',
      loading: false
    },
  ]

  async onTriggerClick (item: any) {
    Vue.set(item, 'loading', true)
    await this.$store.dispatch('triggerEmailNotification', { id: item.id, oppId: this.opportunity.id })
    Vue.set(item, 'loading', false)
  }
}
</script>
